import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edit\"><path d=\"M.647 12.12l9.411-9.41 3.19 3.19-9.41 9.411H.647v-3.19zm15.074-8.692l-1.595 1.595-3.19-3.19L12.53.236c.372-.372.757-.372 1.156 0L15.72 2.27c.372.399.372.784 0 1.157z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol